import { Component, Input, OnInit } from '@angular/core';
import {
  PictureTagInfoInterface,
  WagtailImageSliderRenderInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";


@Component({
    selector: 'wagtail-page-element-shop-imageslider',
    templateUrl: './shop-imageslider.component.html',
    styleUrls: ['./shop-imageslider.component.scss'],
    standalone: false
})
export class ShopImagesliderComponent implements OnInit {

  @Input() definition?: WagtailPageContentElementInterface<WagtailImageSliderRenderInterface>
  slides?: PictureTagInfoInterface[]

  ngOnInit(): void {
    if (this.definition) {
      this.slides = this.definition.value.slides
    }
  }
  
}
